import { API_PREFIXES } from 'CONST';

// const process = { env: __DOTENV__ || window.env };

export const apiPrefix = API_PREFIXES.msg;


